const messages = {
  en: {
    defaultPageTitle: 'Personal data form',
    home: {
      pageTitle: 'Personal data form',
      title: 'Personal information management at {name}',
      privacyText: 'The privacy is important, {name} is committed to protect the personal data of all its customers.',
      pageContent: 'By filling out the following form you can request the verification of your data and/or proceed with their removal from the information systems of {name}. The company reserves 30 working days for the implementation.'
    },
    privacyForm: {
      labelName: 'Name',
      labelSurname: 'Surname',
      labelNote: 'Notes',
      checkSendCopy: 'I request that I be notified about which data are in possession of {legalName} and the modalities of their archiving.',
      checkMailchimp: 'I request that my data will be deleted from Mailchimp platform used by {legalName} for sending newsletters.',
      checkRemoveAll: 'I request that my data will be deleted from all, online and offline, information systems of {legalName}.',
      checkRemoveMarketing: 'I request that my data will be deleted from the direct marketing platforms used by {legalName}.',
      checkPrivacy: 'Personal data collected through this form will be communicated to Quamm S.r.l. exclusively for the purpose of your request.',
      checkPrivacyQuamm: 'Personal data collected through this form will be processed exclusively for the purpose of your request.',
      labelSubmit: 'Send request'
    },
    formSuccess: {
      pageTitle: 'Request successfully sent',
      title: 'We have received your request.',
      content: 'It will be processed within 30 working days.'
    },
    formFailure: {
      pageTitle: 'Request not sent',
      title: 'There was a problem with your request.',
      content: 'Try again to <a href="{url}">send the request</a>, or contact <a href="mailto:{email}">{email}</a>.'
    },
    notFound: {
      pageTitle: 'Page not found',
      title: 'Page not found',
      content: ''
    }
  },
  it: {
    defaultPageTitle: 'Modulo gestione dati personali',
    home: {
      pageTitle: 'Modulo gestione dati personali',
      title: 'Modulo di gestione dei dati personali presso {name}',
      privacyText: 'La privacy è importante, {name} si impegna a proteggere i dati personali di tutti i suoi clienti.',
      pageContent: 'Compilando il seguente modulo potrai richiedere la verifica dei tuoi dati e/o dare seguito alla loro rimozione dai sistemi informativi di {name}. L’azienda si riserva 30gg. lavorativi per l’attuazione.'
    },
    privacyForm: {
      labelName: 'Nome',
      labelSurname: 'Cognome',
      labelNote: 'Note',
      checkSendCopy: 'Richiedo che mi vengano comunicati quali dati a me riferiti sono in possesso di {legalName} e le modalità della loro archiviazione.',
      checkMailchimp: 'Richiedo che i miei dati vengano rimossi dalla piattaforma Mailchimp utilizzata da {legalName} per l’invio di newsletter.',
      checkRemoveAll: 'Richiedo che i miei dati vengano rimossi da tutti i sistemi informativi, online e offline, di {legalName}.',
      checkRemoveMarketing: 'Richiedo che i miei dati vengano rimossi dalle piattaforme di marketing diretto utilizzate da {legalName}.',
      checkPrivacy: 'I dati personali raccolti attraverso questo modulo verranno comunicati a Quamm S.r.l. esclusivamente per le finalità della vostra richiesta.',
      checkPrivacyQuamm: 'I dati personali raccolti attraverso questo modulo verranno trattati esclusivamente per le finalità della vostra richiesta.',
      labelSubmit: 'Invia richiesta'
    },
    formSuccess: {
      pageTitle: 'Richiesta inviata',
      title: 'Abbiamo ricevuto la sua richiesta.',
      content: 'Sarà evasa entro 30 giorni lavorativi.'
    },
    formFailure: {
      pageTitle: 'Richiesta non inviata',
      title: "C'è stato un problema nella gestione della sua richiesta.",
      content: 'Riprova ad <a href="{url}">inviare la richiesta</a>, o contatta <a href="mailto:{email}">{email}</a>.'
    },
    notFound: {
      pageTitle: 'Pagina non trovata',
      title: 'Pagina non trovata',
      content: ''
    }
  }
}

export default messages
